/// <reference lib="dom" />
import { bootstrapApplication } from '@angular/platform-browser';
import { PreloadAllModules, RouteReuseStrategy, provideRouter, withPreloading } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeBg from '@angular/common/locales/bg';
import localeDe from '@angular/common/locales/de';
import localeNl from '@angular/common/locales/nl';
import localePt from '@angular/common/locales/pt';
import localeRo from '@angular/common/locales/ro';
import localeTr from '@angular/common/locales/tr';
import { LOCALE_ID } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateCompiler, provideTranslateService } from '@ngx-translate/core';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { acceptLanguageInterceptor } from './app/services/accept-language.interceptor';
import { authenticationInterceptor } from './app/services/authentication.interceptor';
import { routerAnimation } from './app/utils/router-animation.utils';

// For datepipe, currency pipe, etc.
registerLocaleData(localeNl);
registerLocaleData(localeTr);
registerLocaleData(localePt);
registerLocaleData(localeRo);
registerLocaleData(localeBg);
registerLocaleData(localeDe);

bootstrapApplication(AppComponent, {
  providers: [
    { provide: LOCALE_ID, useValue: 'nl-NL' },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      // Allows us to use signal based inputs in components used with ionic modal controller
      useSetInputAPI: true,
      // Use custom animations, because the default iOS and MD animations are very complex and easily break
      navAnimation: routerAnimation,
    }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimations(),
    provideTranslateService({
      defaultLanguage: 'en',
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler,
      },
    }),
    provideHttpClient(withInterceptors([authenticationInterceptor, acceptLanguageInterceptor])),
  ],
});
